import ProductCard, { coverAspectFor } from '@v2/shared/components/ProductCard';
import { Product } from '@v2/shared/lib/types';

type Props = {
  products: Product[];
  /** The GA4 `item_list_name` every card reports under. */
  list: string;
  /** Where this page starts in the whole result set, so positions stay absolute. */
  startOffset: number;
  /** Passed to each card; see ProductCard. */
  showMsrp: boolean;
};

/**
 * The listing grid.
 *
 * `ProductCard` — the same component the home page's bands draw, which is what "product
 * cards should match the other cards" asks for and also what stops the listing drifting
 * away from the rest of the site the next time a card changes. The one thing it leaves
 * off is the "Save X%" line, which a listing of sixteen cards does not want repeated under
 * every price.
 *
 * `coverAspectFor` is called once for the whole page rather than per card, which is the
 * point of it — every cover on the page gets the same box, so the names and prices below
 * them line up instead of going ragged.
 */
export default function ProductGrid({ products, list, startOffset, showMsrp }: Props) {
  if (products.length === 0) {
    return (
      <p className="rounded-xl border border-solid border-slate-200 bg-white px-5 py-8 text-center text-slate-600">
        No magazines match these filters.
      </p>
    );
  }

  const coverAspect = coverAspectFor(products);

  return (
    <ul className="m-0 grid list-none grid-cols-2 gap-6 p-0 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
      {products.map((product, index) => (
        <li key={product.id}>
          <ProductCard
            product={product}
            coverAspect={coverAspect}
            showSavings={false}
            showMsrp={showMsrp}
            list={list}
            index={startOffset + index + 1}
          />
        </li>
      ))}
    </ul>
  );
}
